import React from 'react'
import './style.css'
import BreadcrumbComponent from '../common/BreadcrumbComponent';

import FeatureTemplate from '../template/FeatureTemplate';
import FeatureFeedbackComponent from '../template/FeatureFeedbackComponent';
import { rankVendorsData } from '../template/Data';

export default function VendorRank({ selectedParent, selectedChild }) {
    return (
        <section className='Home_container'>
            <section className="Home_firstContainer">
                <BreadcrumbComponent selectedParent={selectedParent} selectedChild={selectedChild} />
                <div className="Home_heading">
                    <h1>Rank Vendors</h1>
                </div>
            </section>
            <main className='VendorOnboard_adding-2'>
                <FeatureTemplate data={rankVendorsData} />
                <FeatureFeedbackComponent name="Vendor-Rank" />
            </main>
        </section>
    )
}
